import { createSlice } from '@reduxjs/toolkit'
import moment from 'moment'
import hit from 'src/services/manager'
import { setToast } from 'src/redux/toast'

const initialState = {
    list: null
}

const ordersSlice = createSlice({
    name: "posts",
    initialState,
    reducers: {
        setAllPosts: (state, action) => {
            state.list = action.payload
        }
    }
})

export const { setAllPosts } = ordersSlice.actions

export const getPostListThunk = (team_id = null, dateRanges = null) => {
    return async (dispatch) => {
        try {
            let res = null
            if (team_id) {
                if (dateRanges) {
                    let query = `startDate=${moment(dateRanges[0]).format("MM/DD/yyyy")}&endDate=${moment(dateRanges[1]).format("MM/DD/yyyy")}`
                    res = await hit(`/admins/posts/team/${team_id}?${query}`, "get")
                } else {
                    res = await hit(`/admins/posts/team/${team_id}`, "get")
                }
            } else {
                res = await hit(`/admins/posts/`, "get")
            }
            if (!res.err) {
                dispatch(setAllPosts(res?.data))
            } else {
                dispatch(setToast({ show: true, message: res?.msg || "Failed to load posts", severity: "error" }))
            }
            return res
        } catch (err) {
            dispatch(setToast({ show: true, message: "Failed to load posts", severity: "error" }))
            return { err: true, msg: "Failed to load posts" }
        }
    }
}

export default ordersSlice.reducer